import {isPayrollOperationPending} from 'app/services/operation-conflict';
import {HTTP_STATUS_CODES} from '../shared.constants/all-constants';
import {
  ReportDatepickerError,
  ReportDatepickerErrorView
} from './report-datepicker.types';

export function applyReportDatepickerError(
  view: ReportDatepickerErrorView, error: ReportDatepickerError
): void {
  if (isPayrollOperationPending(error)) { view.payrollOperationPending = true; return; }
  switch (error.status) {
    case HTTP_STATUS_CODES.NOT_ACCEPTABLE: view.wrongHeadError = true; break;
    case HTTP_STATUS_CODES.PRECONDITION_FAILED: view.wrongIntervalError = true; break;
    case HTTP_STATUS_CODES.FAILED_DEPENDENCY: view.noScheduleError = true; break;
    case HTTP_STATUS_CODES.PRECONDITION_REQUIRED: view.emptyIntervalError = true; break;
    case HTTP_STATUS_CODES.CONFLICT: view.wrongError409 = true; break;
    case HTTP_STATUS_CODES.BAD_REQUEST: view.wrongError400 = true; break;
    default: view.wrongError = true; break;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-error.state.ts